<div
  class="flex flex-col items-center justify-center text-surface-highlight dark:text-surface-highlight-darkmode w-full h-full"
>
  <ng-icon name="heroSignalSlash" size="64" class="!block" />
  <p class="leading-6 text-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode">
    {{ 'shared.errorComponent.loadError' | transloco }}
  </p>
  <p
    class="empty:hidden leading-6 text-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode"
  >
    <ng-content />
  </p>
  @if (enableRetry()) {
    <ui-button mode="outlined" (click)="clickRetry.emit()" class="block mt-4">
      <ng-icon name="heroArrowPath" size="20" class="!block" slot="start" />
      {{ 'shared.errorComponent.retryButton' | transloco }}
    </ui-button>
  }
</div>
